module.exports = __webpack_public_path__ + "img/signature.0feed144.svg";